"use client";

import { useContext } from "react";

import { consentContext } from "../lib";

export const useConsentContext = () => useContext(consentContext);
